(() => {
  const initialize = () => {
    const page = document.querySelector('[data-dm-shop-category]');
    const copy = page?.querySelector('.dm-parts-hero-copy');
    const intro = document.querySelector('[data-dm-category-intro]');
    if (!copy || !intro) return;
    if (!copy.querySelector('.dm-category-short-intro')) copy.append(intro.content.cloneNode(true));
    page.classList.add('dm-category-ready');
    page.querySelectorAll('a[href="/collections/suspension-upgrades"]').forEach(link => link.setAttribute('href','/collections/performance-suspension-upgrades-canada'));
    page.querySelector('.dm-part-card[href="/collections/oil-cooler-upgrades-near-you"]')?.setAttribute('href','/collections/cooling-system-upgrades');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
